/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const Lti1p3SystemRoleFromContextRoleSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('LTI_1P3_SYSTEM_ROLE_FROM_CONTEXT_ROLE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class Lti1p3SystemRoleFromContextRoleSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return Lti1p3SystemRoleFromContextRoleSettingParser.decode(input).map(res => new Lti1p3SystemRoleFromContextRoleSetting(res));
    }
    static unsafeDecode(input) {
        return Lti1p3SystemRoleFromContextRoleSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return Lti1p3SystemRoleFromContextRoleSettingParser.encode(data);
    }
    static schema() {
        return Lti1p3SystemRoleFromContextRoleSettingParser.schema();
    }
}
